export const flatStatusColor = {
  SALE: '#63CBA5',
  SOLD: '#FF6565',
  BOOKED: '#FFB400',
  RESERVE: '#A6A6A6'
};
